const MuiOutlinedInput = {
    styleOverrides: {
        notchedOutline: ({ theme })=>({
                borderColor: theme.palette.border.prominent
            })
    }
};
export { MuiOutlinedInput };

//# sourceMappingURL=outlined-input.js.map